import { type MCPServerInfo } from '../../types';

const GenaiToolboxBigQueryServer: MCPServerInfo = {
  serverId: 'GENAI_TOOLBOX_BIGQUERY',
  name: 'MCP Toolbox for BigQuery',
  slug: 'genai-toolbox-bigquery',
  description:
    "Google's MCP Toolbox for Databases — BigQuery prebuilt. Query and explore BigQuery datasets using natural language via the Model Context Protocol.",
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/googleapis/genai-toolbox',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'ghcr.io/googleapis/genai-toolbox'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['bigqueryProject', 'serviceAccountKeyJson'],
    properties: {
      bigqueryProject: {
        type: 'string',
        description:
          'GCP project ID to run BigQuery jobs against (e.g. my-gcp-project).',
        sensitive: false
      },
      serviceAccountKeyJson: {
        type: 'string',
        description:
          'Paste the full contents of your downloaded service account key JSON file. In GCP Console: IAM & Admin > Service Accounts > your account > Keys > Add Key > Create new key > JSON.',
        sensitive: true
      }
    }
  }
};

export default GenaiToolboxBigQueryServer;
